import React, { useState, useEffect } from "react";

const certificates = [
  { name: "R Shyamala", category: "SAPPHIRE", file: "/images/U1UCI004 - R Shyamala - SAPPHIRE - Certificate.jpg" },
  { name: "Ravi Kumar", category: "DIAMOND", file: "/images/U1UCI259 - Ravi Kumar - DIAMOND - Certificate.jpg" },
  { name: "M K Murugeshan", category: "EMERALD", file: "/images/U1UCI421 - M K Murugeshan - EMERALD - Certificate.jpg" },
  { name: "Veena Bir", category: "AMBER", file: "/images/U1UCI525 - Veena Bir - AMBER - Certificate.jpg" },
  { name: "Veena Bir", category: "TOPAZ", file: "/images/U1UCI529 - Veena Bir - TOPAZ - Certificate.jpg" },
  { name: "", category: "JASPER", file: "/images/JASPER - Certificate.pdf.png" },
  { name: "", category: "RUBY", file: "/images/RUBY - Certificate.pdf.png" },
  { name: "", category: "DAIRY", file: "/images/dairy1.jpg" },
];

const recognitionBands = [
  { name: "Diamond", icon: "/images/award-1.svg", description: "High-impact, executable, transformational ideas", count: 172, color: "from-blue-400 to-cyan-300" },
  { name: "Ruby", icon: "/images/award-2.svg", description: "Sharp, relevant, and practically ONGC-focused", count: 70, color: "from-red-500 to-pink-400" },
  { name: "Sapphire", icon: "/images/award-3.svg", description: "Strong foundation, needs shaping", count: 29, color: "from-blue-600 to-blue-400" },
  { name: "Emerald", icon: "/images/award-4.svg", description: "Everyday problems solved smartly", count: 96, color: "from-green-500 to-emerald-400" },
  { name: "Topaz", icon: "/images/award-5.svg", description: "Innovative, needing some refinement", count: 64, color: "from-yellow-500 to-amber-400" },
  { name: "Jasper", icon: "/images/award-6.svg", description: "Out-of-the-box thinking", count: 25, color: "from-orange-500 to-red-400" },
  { name: "Amber", icon: "/images/award-7.svg", description: "Acknowledgement for participation", count: 135, color: "from-amber-600 to-yellow-600" }
];

const ParticipationAwards = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const totalItems = certificates.length;
  const angleStep = 360 / totalItems;

  return (
    <section className="bg-black text-white px-6 pt-10 pb-12 relative overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:gap-12">
          {/* LEFT CONTENT */}
          <div className="flex-1 mt-6 md:mt-12">
            <h2 className="text-2xl md:text-3xl font-bold mb-5 bg-gradient-to-r from-green-400 via-red-500 to-green-500 bg-clip-text text-transparent leading-tight">
              Every Idea Matters
            </h2>
            <div className="h-1 w-24 bg-gradient-to-r from-green-400 to-red-500 mb-6" />
            <p className="text-white text-[1.1rem] leading-[1.7] mb-6">
              Participation Awards were presented to every individual who took the initiative to think deeply, articulate, and submit{" "}
              <span className="text-white font-semibold">Use Case Ideas for Udbhav 1.0</span>. These awards recognized the{" "}
              <span className="text-white font-semibold">courage to question existing ways of working</span> and the willingness to step forward with new possibilities.
            </p>
            <p className="text-white text-[1.1rem] leading-[1.7]">
              Every idea submitted during Udbhav 1.0 played a role in fostering a{" "}
              <span className="text-white font-semibold">culture of curiosity, learning, and innovation</span> across the organization.
            </p>
          </div>

 {/* RIGHT GIFTS / CERTIFICATE ROTATOR */}
<div className="flex-1 flex justify-center md:justify-end mt-16 md:mt-4">
  <div 
    className="perspective-container" 
    style={{ 
      height: isMobile ? "240px" : "320px", 
      width: isMobile ? "100%" : "520px" 
    }}
  >
    <div className="carousel-3d">
      {certificates.map((cert, index) => {
        // INCREASED radius + DECREASED width creates the "gap"
        const radius = isMobile ? 180 : 300; 
        const itemWidth = isMobile ? "140px" : "240px";
        
        return (
          <div
            key={index}
            className="carousel-item"
            style={{
              width: itemWidth,
              transform: `translate(-50%, -50%) rotateY(${angleStep * index}deg) translateZ(${radius}px)`,
            }}
          >
            <div 
              className="certificate-card" 
              style={{ 
                height: isMobile ? "100px" : "240px",
                // Adding a subtle border to help distinguish items on mobile
                border: isMobile ? "1px solid rgba(255,255,255,0.1)" : "none" 
              }}
            >
              <img 
                src={cert.file} 
                alt={`${cert.category} Certificate`} 
                className="certificate-image" 
              />
            </div>
            <p 
              className="category mt-2" 
              style={{ 
                color: "#fff", 
                fontSize: isMobile ? "0.55rem" : "0.75rem",
                opacity: 0.9 
              }}
            >
              {cert.category}
            </p>
          </div>
        );
      })}
    </div>
  </div>
</div>
        </div>

        {/* Local Events Section */}
        <div className="pt-24 md:pt-[220px] lg:pt-[200px]">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-12 bg-gradient-to-r from-green-400 via-red-500 to-green-500 bg-clip-text text-transparent animate-gradient leading-snug">
            Recognition at Local Events
          </h3>
          <div className="grid gap-8 px-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
            {[
              { img: "/images/dsc_7494[1].jpg", caption: "Asset-Level Award Distribution" },
              { img: "/images/dsc_7493[1].jpg", caption: "Participation Recognition Event" },
              { img: "/images/jitendra kumar_wellAI_392.jpg", caption: "Innovation Achievement Felicitation" },
              { img: "/images/Inventory Forecasting & Deduplication U1UCI447_A & B Award Ceremony.jpeg", caption: "Employee Recognition Ceremony" },
            ].map((item, index) => (
              <div key={index} className="group relative overflow-hidden rounded-2xl border-2 border-white/10 shadow-2xl transition-all duration-700">
                <img src={item.img} alt={item.caption} className="w-full h-[240px] object-cover transition-transform duration-700 group-hover:scale-110" />
                <p className="mt-4 text-center text-sm font-semibold text-white">{item.caption}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Award Categories Section */}
        <div className="mt-24 md:mt-40 lg:mt-24 mb-12">
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              <span className="bg-gradient-to-r from-green-400 via-red-500 to-green-500 bg-clip-text text-transparent">
                Udbhav 1.0 featured seven award categories, outlined below
              </span>
            </h3>
            <p className="text-gray-300 text-base max-w-3xl mx-auto">
              To structure this innovation wave, ideas were categorized into{" "}
              <span className="text-white font-semibold">seven distinct recognition bands</span>, recognizing both bold game-changers and creative sparks.
            </p>
          </div>

          {/* DESKTOP TABLE */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full border border-gray-600 border-collapse">
              <thead>
                <tr>
                  <th className="border border-gray-600 py-4 px-6 text-center text-base font-semibold text-gray-200">Recognition Band</th>
                  <th className="border border-gray-600 py-4 px-6 text-center text-base font-semibold text-gray-200">Description</th>
                  <th className="border border-gray-600 py-4 px-6 text-center text-base font-semibold text-gray-200">No. of Ideas</th>
                </tr>
              </thead>
              <tbody>
                {recognitionBands.map((band, index) => (
                  <tr key={index}>
                    <td className="border border-gray-600 py-4 px-6">
                      <div className="flex items-center gap-3">
                        <img src={band.icon} alt={band.name} className="w-6 h-6 object-contain" />
                        <span className={`font-medium text-base bg-gradient-to-r ${band.color} bg-clip-text text-transparent`}>{band.name}</span>
                      </div>
                    </td>
                    <td className="border border-gray-600 py-4 px-6 text-gray-300 text-sm">{band.description}</td>
                    <td className="border border-gray-600 py-4 px-6 text-center font-medium text-base text-white">{band.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* MOBILE CARDS */}
          <div className="md:hidden space-y-4">
            {recognitionBands.map((band, index) => (
              <div key={index} className="bg-gray-900/50 border border-gray-700 rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-3">
                    <img src={band.icon} alt={band.name} className="w-6 h-6 object-contain" />
                    <span className={`font-medium text-base bg-gradient-to-r ${band.color} bg-clip-text text-transparent`}>{band.name}</span>
                  </div>
                  <span className="font-semibold text-lg text-white">{band.count}</span>
                </div>
                <p className="text-gray-300 text-sm">{band.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes gradient { 0%, 100% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } }
        .animate-gradient { background-size: 200% 200%; animation: gradient 5s ease infinite; }
        .perspective-container { perspective: 1200px; margin: 0 auto; position: relative; }
        .carousel-3d { position: relative; width: 100%; height: 100%; transform-style: preserve-3d; animation: rotate3d 26s linear infinite; }
        @keyframes rotate3d { from { transform: rotateY(0deg); } to { transform: rotateY(360deg); } }
        .carousel-item { position: absolute; top: 50%; left: 50%; text-align: center; transition: transform 0.4s ease; backface-visibility: hidden; }
        .certificate-card { width: 100%; background: #fff; border-radius: 14px; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,0.6); }
        .certificate-image { width: 100%; height: 100%; object-fit: contain; display: block; }
        .category { letter-spacing: 2px; font-weight: 600; }
      `}</style>
    </section>
  );
};

export default ParticipationAwards;